export const roles = [
  { id: 1, name: "主人公" },
  { id: 2, name: "ヒーロー" },
  { id: 3, name: "ヒロイン" },
  { id: 4, name: "サブキャラ" },
  { id: 5, name: "モブ" },
]

export type Roles = typeof roles

export const sex = [
  { id: 1, name: "男" },
  { id: 2, name: "女" },
  { id: 3, name: "不明" },
]

export type Sex = typeof sex

export const hair_style = [
  { id: 1, name: "ベリーショート" },
  { id: 2, name: "ショート" },
  { id: 3, name: "ボブ" },
  { id: 4, name: "ミディアム" },
  { id: 5, name: "セミロング" },
  { id: 6, name: "ロング" },
  { id: 7, name: "スーパーロング" },
]

export type HairStyle = typeof hair_style

export const hair_arrange = [
  { id: 1, name: "ストレート" },
  { id: 2, name: "パーマ" },
  { id: 3, name: "ポニーテール" },
  { id: 4, name: "ハーフアップ" },
  { id: 5, name: "マッシュ" },
  { id: 6, name: "編み込み" },
  { id: 7, name: "お団子" },
  { id: 8, name: "ツインテール" },
  { id: 9, name: "サイドテール" },
  { id: 10, name: "おさげ" },
  { id: 11, name: "三つ編み" },
]

export type HairArrange = typeof hair_arrange

export const hair_color = [
  { id: 1, name: "黒" },
  { id: 2, name: "白" },
  { id: 3, name: "赤" },
  { id: 4, name: "黄" },
  { id: 5, name: "緑" },
  { id: 6, name: "青" },
  { id: 7, name: "紫" },
  { id: 8, name: "茶" },
  { id: 9, name: "灰" },
  { id: 10, name: "銀" },
  { id: 11, name: "金" },
]

export type HairColor = typeof hair_color

export const eye_color = [
  { id: 1, name: "黒" },
  { id: 2, name: "白" },
  { id: 3, name: "赤" },
  { id: 4, name: "黄" },
  { id: 5, name: "緑" },
  { id: 6, name: "青" },
  { id: 7, name: "紫" },
  { id: 8, name: "茶" },
  { id: 9, name: "灰" },
  { id: 10, name: "銀" },
  { id: 11, name: "金" },
]

export type EyeColor = typeof eye_color
